import { neptuneUrls } from '@neptune/shared/common-domain';
import { tick } from '@neptune/shared/common-util';
import { AppRoute } from '@neptune/shared/routing-domain';

import { API_TOKEN_MODAL_NAME } from 'components/modals/api-token-modal/ApiTokenModal';
import { showGenericModal } from 'state/ui/modals/generic/actions';
import { isUserAuthenticated } from 'state/users/current-user/selectors';
import viewsRoutes from 'views/routes';

import { redirectToWorkspaceDashboard } from './actions';

const applicationRoutes: AppRoute[] = [
  {
    name: 'home',
    path: '/',
    onlyLoggedUser: true,
    onActivate(dispatch) {
      return () => {
        tick(() => dispatch(redirectToWorkspaceDashboard()));
      };
    },
  },
  {
    name: 'get-my-api-token',
    path: '/get_my_api_token',
    onActivate(dispatch, getState) {
      return () => {
        const authenticated = isUserAuthenticated(getState());

        if (authenticated) {
          tick(() => dispatch(redirectToWorkspaceDashboard())).then(() =>
            dispatch(showGenericModal(API_TOKEN_MODAL_NAME)),
          );
        } else {
          window.location.replace(neptuneUrls.setupApiTokenDoc);
        }
      };
    },
  },
  ...viewsRoutes,
];

export default applicationRoutes;
